// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BaseCard{background-color:#f2f2f5;overflow:hidden}.is-ln4-theme .BaseCard,.is-orange-dark-theme .BaseCard{background-color:#1A1A1A}.is-dr3-theme .BaseCard{background-color:rgba(26,26,26,.4)}.BaseCard--rounded{border-radius:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
